export const GET_COMPANY_USER_INFO_LIST =  'GET_COMPANY_USER_INFO_LIST';